(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["charcode-membership-account"]) return;
  try {
    
(() => {
  const validDob = (year,month,day) => {
    if (!year || !month || !day) return '';
    const iso = `${year}-${month}-${day}`;
    const check = new Date(`${iso}T00:00:00Z`);
    if (Number.isNaN(check.getTime())) return '';
    if (check.getUTCFullYear() !== Number(year) || check.getUTCMonth()+1 !== Number(month) || check.getUTCDate() !== Number(day)) return '';
    if (check.getTime() > Date.now()) return '';
    return iso;
  };

  document.querySelectorAll('[data-cc-membership-purchase]').forEach((form) => {
    if (form.dataset.ready === 'true') return;
    form.dataset.ready = 'true';
    const day=form.querySelector('[data-cc-dob-day]');
    const month=form.querySelector('[data-cc-dob-month]');
    const year=form.querySelector('[data-cc-dob-year]');
    const size=form.querySelector('[data-cc-size]');
    const fit=form.querySelector('[data-cc-fit]');
    const sizeCustomWrap=form.querySelector('[data-cc-size-custom-wrap]');
    const sizeCustom=form.querySelector('[data-cc-size-custom]');
    const fitCustomWrap=form.querySelector('[data-cc-fit-custom-wrap]');
    const fitCustom=form.querySelector('[data-cc-fit-custom]');
    const error=form.querySelector('[data-cc-error]');
    const button=form.querySelector('button[type="submit"]');
    const showError=(message)=>{error.textContent=message;error.hidden=!message;};
    const sync=()=>{sizeCustomWrap.hidden=size.value!=='__custom__';fitCustomWrap.hidden=fit.value!=='__custom__';};
    const resolvedSize=()=>size.value==='__custom__'?sizeCustom.value.trim():size.value;
    const resolvedFit=()=>fit.value==='__custom__'?fitCustom.value.trim():fit.value;
    size.addEventListener('change',sync);fit.addEventListener('change',sync);sync();

    form.addEventListener('submit',async(event)=>{
      event.preventDefault();showError('');
      const dob=validDob(year.value,month.value,day.value);
      const finalSize=resolvedSize();
      const finalFit=resolvedFit();
      if(!dob){showError('Please enter a valid date of birth.');return;}
      if(!finalSize){showError('Please select or write your preferred size.');return;}
      if(!finalFit){showError('Please select or write your preferred fit.');return;}
      button.disabled=true;
      try{
        const response=await fetch(`${window.Shopify.routes.root}cart/add.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(form.dataset.membershipVariantId),quantity:1,properties:{
          'Order Type':'MEMBER ORDER - MEMBERSHIP PURCHASE','Date of Birth':dob,'Preferred Size':finalSize,'Preferred Fit':finalFit,'Usual Fit / Size':finalSize,'Membership Term':'1 Year','Free Customization Benefit':'Active for 1 year after paid order','Birthday Gift Benefit':'Included - 24 hour claim window','_Charcode Service':'membership'
        }}]})});
        if(!response.ok){const payload=await response.json().catch(()=>({}));throw new Error(payload.description||'We could not add the membership. Please try again.');}
        await fetch(`${window.Shopify.routes.root}cart/update.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({attributes:{'Cord Cult Membership Purchase':'Yes','Membership Order Type':'MEMBER ORDER - MEMBERSHIP PURCHASE','Membership Date of Birth':dob,'Membership Preferred Size':finalSize,'Membership Preferred Fit':finalFit,'Membership Term':'1 Year'}})});
        window.location.assign(form.dataset.cartUrl);
      }catch(requestError){showError(requestError.message||'We could not add the membership. Please try again.');button.disabled=false;}
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["charcode-product-customization-v3-backup"] && !Shopify.designMode) return;
  try {
    
(() => {
  const makeDob = (year, month, day) => {
    if (!year || !month || !day) return '';
    const iso = `${year}-${month}-${day}`;
    const check = new Date(`${iso}T00:00:00Z`);
    if (Number.isNaN(check.getTime())) return '';
    if (check.getUTCFullYear() !== Number(year) || check.getUTCMonth() + 1 !== Number(month) || check.getUTCDate() !== Number(day)) return '';
    if (check.getTime() > Date.now()) return '';
    return iso;
  };

  document.querySelectorAll('[data-cc-customizer]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const forms = [...document.querySelectorAll('product-form form[data-type="add-to-cart-form"]')];
    const form = forms.find((candidate) => candidate.offsetParent !== null) || forms[0];
    if (!form) return;
    const buttonHost = form.querySelector('.product-form__buttons');
    if (buttonHost) form.insertBefore(root, buttonHost); else form.prepend(root);

    const modal = root.querySelector('[data-cc-modal]');
    const panel = root.querySelector('[data-cc-panel]');
    if (modal) document.body.appendChild(modal);

    const memberActive = root.dataset.memberActive === 'true';
    const loggedIn = root.dataset.loggedIn === 'true';
    const openButtons = [root.querySelector('[data-cc-open]'), root.querySelector('[data-cc-edit]')].filter(Boolean);
    const closeButtons = [...modal.querySelectorAll('[data-cc-close]')];
    const resetButton = modal.querySelector('[data-cc-reset]');
    const saveButton = modal.querySelector('[data-cc-save]');
    const removeButton = root.querySelector('[data-cc-remove]');
    const savedBox = root.querySelector('[data-cc-saved]');
    const trigger = root.querySelector('[data-cc-open]');
    const savedSummary = root.querySelector('[data-cc-saved-summary]');
    const dynamicCheckout = form.querySelector('.btn-checkout-dynamic,.shopify-payment-button');
    const error = modal.querySelector('[data-cc-error]');

    const sizeOptions = [...modal.querySelectorAll('[data-cc-custom-size-option]')];
    const customSizeWrap = modal.querySelector('[data-cc-custom-size-wrap]');
    const customSizeText = modal.querySelector('[data-cc-custom-size-text]');
    const colorOptions = [...modal.querySelectorAll('[data-cc-color-option]')];
    const customColorWrap = modal.querySelector('[data-cc-custom-color-wrap]');
    const customColorText = modal.querySelector('[data-cc-custom-color-text]');
    const customText = modal.querySelector('[data-cc-text]');
    const textColor = modal.querySelector('[data-cc-text-color]');
    const placement = modal.querySelector('[data-cc-placement]');
    const customPlacementWrap = modal.querySelector('[data-cc-custom-placement-wrap]');
    const customPlacement = modal.querySelector('[data-cc-custom-placement]');
    const instructions = modal.querySelector('[data-cc-instructions]');
    const choices = [...modal.querySelectorAll('[data-cc-choice]')];
    const join = modal.querySelector('[data-cc-join]');
    const day = modal.querySelector('[data-cc-dob-day]');
    const month = modal.querySelector('[data-cc-dob-month]');
    const year = modal.querySelector('[data-cc-dob-year]');
    const profileSize = modal.querySelector('[data-cc-profile-size]');
    const profileSizeCustomWrap = modal.querySelector('[data-cc-profile-size-custom-wrap]');
    const profileSizeCustom = modal.querySelector('[data-cc-profile-size-custom]');
    const profileFit = modal.querySelector('[data-cc-profile-fit]');
    const reviewSize = modal.querySelector('[data-cc-review-size]');
    const reviewColor = modal.querySelector('[data-cc-review-color]');
    const reviewText = modal.querySelector('[data-cc-review-text]');
    const reviewPlacement = modal.querySelector('[data-cc-review-placement]');
    const reviewFee = modal.querySelector('[data-cc-review-fee]');

    let configured = false;
    let lastFocus = null;

    const showError = (message) => { if (!error) return; error.textContent = message; error.hidden = !message; };
    const checkedValue = (items) => items.find((item) => item.checked)?.value || '';
    const selectedChoice = () => choices.find((choice) => choice.checked)?.value || '';
    const resolvedSize = () => checkedValue(sizeOptions) === '__custom__' ? customSizeText.value.trim() : checkedValue(sizeOptions);
    const resolvedColor = () => checkedValue(colorOptions) === '__custom__' ? customColorText.value.trim() : checkedValue(colorOptions);
    const resolvedPlacement = () => placement.value === '__custom__' ? customPlacement.value.trim() : placement.value;
    const resolvedProfileSize = () => profileSize?.value === '__custom__' ? profileSizeCustom?.value.trim() : profileSize?.value || '';
    const feeLabel = () => memberActive ? 'FREE · Member' : selectedChoice() === 'membership' ? 'FREE · Joining membership' : selectedChoice() === 'fee' ? '₹299 / item' : 'Choose option';

    const syncConditionalFields = () => {
      if (customSizeWrap) customSizeWrap.hidden = checkedValue(sizeOptions) !== '__custom__';
      if (customColorWrap) customColorWrap.hidden = checkedValue(colorOptions) !== '__custom__';
      if (customPlacementWrap) customPlacementWrap.hidden = placement?.value !== '__custom__';
      if (join) join.hidden = selectedChoice() !== 'membership';
      if (profileSizeCustomWrap) profileSizeCustomWrap.hidden = profileSize?.value !== '__custom__';
      syncReview();
    };

    const syncReview = () => {
      if (reviewSize) reviewSize.textContent = resolvedSize() || '—';
      if (reviewColor) reviewColor.textContent = resolvedColor() || '—';
      if (reviewText) reviewText.textContent = customText?.value.trim() || 'No text';
      if (reviewPlacement) reviewPlacement.textContent = resolvedPlacement() || '—';
      if (reviewFee) reviewFee.textContent = feeLabel();
    };

    const openModal = () => {
      lastFocus = document.activeElement;
      modal.hidden = false;
      modal.setAttribute('aria-hidden','false');
      document.body.classList.add('cc-customizer-open');
      syncConditionalFields();
      window.setTimeout(() => panel.focus(), 10);
    };

    const closeModal = () => {
      modal.hidden = true;
      modal.setAttribute('aria-hidden','true');
      document.body.classList.remove('cc-customizer-open');
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    };

    const clearFields = () => {
      sizeOptions.forEach((item) => { item.checked = false; });
      colorOptions.forEach((item) => { item.checked = false; });
      if (customSizeText) customSizeText.value = '';
      if (customColorText) customColorText.value = '';
      if (customText) customText.value = '';
      if (textColor) textColor.value = '';
      if (placement) placement.value = '';
      if (customPlacement) customPlacement.value = '';
      if (instructions) instructions.value = '';
      choices.forEach((item) => { item.checked = false; });
      configured = false;
      if (savedBox) savedBox.hidden = true;
      if (trigger) trigger.hidden = false;
      if (dynamicCheckout) dynamicCheckout.hidden = false;
      showError('');
      syncConditionalFields();
    };

    const validateCustomization = () => {
      const rawSize = checkedValue(sizeOptions);
      const rawColor = checkedValue(colorOptions);
      if (!rawSize) return 'Please choose the required size.';
      if (rawSize === '__custom__' && !customSizeText.value.trim()) return 'Please write your custom size or measurements.';
      if (!rawColor) return 'Please choose the requested colour.';
      if (rawColor === '__custom__' && !customColorText.value.trim()) return 'Please write the colour you want.';
      if (customText.value.trim() && !placement.value) return 'Please choose a placement for your custom text.';
      if (placement.value === '__custom__' && !customPlacement.value.trim()) return 'Please describe your custom placement.';
      if (!memberActive && !selectedChoice()) return 'Choose membership or continue with the ₹299 customization fee.';
      if (selectedChoice() === 'membership' && !loggedIn) return 'Log in or create an account to add membership, or choose the ₹299 option.';
      if (selectedChoice() === 'membership') {
        const dob = makeDob(year?.value, month?.value, day?.value);
        if (!dob) return 'Please enter a valid date of birth for membership.';
        if (!resolvedProfileSize()) return 'Please select or enter your preferred membership size.';
        if (!profileFit?.value) return 'Please select your preferred fit for membership.';
      }
      return '';
    };

    openButtons.forEach((button) => button.addEventListener('click', openModal));
    closeButtons.forEach((button) => button.addEventListener('click', closeModal));
    resetButton?.addEventListener('click', clearFields);
    removeButton?.addEventListener('click', clearFields);

    [...sizeOptions, ...colorOptions, ...choices].forEach((field) => field.addEventListener('change', syncConditionalFields));
    [customSizeText, customColorText, customText, textColor, placement, customPlacement, instructions, profileSize, profileSizeCustom, profileFit, day, month, year].forEach((field) => {
      field?.addEventListener('input', syncConditionalFields);
      field?.addEventListener('change', syncConditionalFields);
    });

    saveButton?.addEventListener('click', () => {
      showError('');
      const validationError = validateCustomization();
      if (validationError) {
        showError(validationError);
        error?.scrollIntoView({behavior:'smooth',block:'nearest'});
        return;
      }
      configured = true;
      const pieces = [resolvedSize(), resolvedColor()];
      if (customText.value.trim()) pieces.push(`Text: ${customText.value.trim()}`);
      savedSummary.textContent = pieces.join(' · ');
      savedBox.hidden = false;
      trigger.hidden = true;
      if (dynamicCheckout) dynamicCheckout.hidden = true;
      closeModal();
    });

    modal.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { event.preventDefault(); closeModal(); return; }
      if (event.key !== 'Tab') return;
      const focusables = [...panel.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter((el) => el.offsetParent !== null);
      if (!focusables.length) return;
      const first = focusables[0];
      const last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    const addItems = async (items, attributes) => {
      const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({items})
      });
      if (!addResponse.ok) {
        const payload = await addResponse.json().catch(() => ({}));
        throw new Error(payload.description || 'Unable to add customized item to cart.');
      }
      await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method:'POST', headers:{'Content-Type':'application/json',Accept:'application/json'}, body:JSON.stringify({attributes})
      });
      window.location.assign(root.dataset.cartUrl);
    };

    form.addEventListener('submit', async (event) => {
      if (!configured) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      showError('');

      const validationError = validateCustomization();
      if (validationError) { openModal(); showError(validationError); return; }

      const variantId = Number(form.querySelector('input[name="id"]')?.value);
      const quantity = Math.max(1, Number(form.querySelector('input[name="quantity"]')?.value || 1));
      if (!variantId) { openModal(); showError('Please select an available product option.'); return; }

      const choice = selectedChoice();
      const isJoining = !memberActive && choice === 'membership';
      const pairId = `cc-${Date.now()}-${window.crypto?.randomUUID?.() || Math.random().toString(36).slice(2)}`;
      const charge = memberActive ? 'Free - Active Member' : isJoining ? 'Free - Membership purchased in this order' : '₹299 per customized item';
      const placementValue = resolvedPlacement();
      const properties = {
        'Order Type':memberActive || isJoining ? 'MEMBER ORDER' : 'NON-MEMBER ORDER',
        'Customization':'Requested',
        'Customization Charge':charge,
        'Customization Size':resolvedSize(),
        'Customization Color':resolvedColor(),
        'Custom Text':customText.value.trim() || 'None',
        'Text / Print Color':textColor.value.trim() || 'Not specified',
        'Customization Placement':placementValue || 'Not applicable',
        'Customization Instructions':instructions.value.trim() || 'None',
        '_Charcode Customization':'true',
        '_Charcode Pair':pairId
      };
      const items = [{id:variantId,quantity,properties}];
      let dob = '';
      let membershipSize = '';

      if (isJoining) {
        dob = makeDob(year.value,month.value,day.value);
        membershipSize = resolvedProfileSize();
        items.push({id:Number(root.dataset.membershipVariantId),quantity:1,properties:{
          'Order Type':'MEMBER ORDER - MEMBERSHIP PURCHASE',
          'Date of Birth':dob,
          'Preferred Size':membershipSize,
          'Preferred Fit':profileFit.value,
          'Usual Fit / Size':membershipSize,
          'Membership Term':'1 Year',
          'Free Customization Benefit':'Active for 1 year after paid order',
          'Birthday Gift Benefit':'Included - 24 hour claim window',
          '_Charcode Service':'membership',
          '_Charcode Pair':pairId
        }});
      } else if (!memberActive) {
        items.push({id:Number(root.dataset.customizationVariantId),quantity,properties:{
          'Order Type':'NON-MEMBER ORDER',
          'Customization Charge':'₹299 per customized item',
          'Customized Product':root.dataset.productTitle,
          'Customized Variant ID':String(variantId),
          'Customization Size':resolvedSize(),
          'Customization Color':resolvedColor(),
          '_Charcode Service':'customization',
          '_Charcode Pair':pairId
        }});
      }

      const attributes = {
        'Cord Cult Customized Order':'Yes',
        'Membership Order Type':memberActive || isJoining ? 'MEMBER ORDER' : 'NON-MEMBER ORDER',
        'Customization Status':charge,
        'Customization Size':resolvedSize(),
        'Customization Color':resolvedColor(),
        'Customization Text':customText.value.trim() || 'None',
        'Customization Placement':placementValue || 'Not applicable'
      };
      if (isJoining) {
        attributes['Cord Cult Membership Purchase']='Yes';
        attributes['Membership Date of Birth']=dob;
        attributes['Membership Preferred Size']=membershipSize;
        attributes['Membership Preferred Fit']=profileFit.value;
        attributes['Membership Term']='1 Year';
      }

      const submitButton = form.querySelector('[name="add"]');
      if (submitButton) submitButton.disabled = true;
      try { await addItems(items,attributes); }
      catch (requestError) {
        openModal();
        showError(requestError.message || 'Unable to add customized item to cart.');
        if (submitButton) submitButton.disabled = false;
      }
    }, true);

    syncConditionalFields();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["charcode-product-customization"] && !Shopify.designMode) return;
  try {
    
(() => {
  const validDob = (year, month, day) => {
    if (!year || !month || !day) return '';
    const iso = `${year}-${month}-${day}`;
    const date = new Date(`${iso}T00:00:00Z`);
    if (Number.isNaN(date.getTime())) return '';
    if (date.getUTCFullYear() !== Number(year) || date.getUTCMonth() + 1 !== Number(month) || date.getUTCDate() !== Number(day)) return '';
    if (date.getTime() > Date.now()) return '';
    return iso;
  };

  const clean = (value) => String(value || '').trim();

  document.querySelectorAll('[data-cc-customizer]').forEach((root) => {
    if (root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';

    const forms = [...document.querySelectorAll('product-form form[data-type="add-to-cart-form"]')];
    const form = forms.find((candidate) => candidate.offsetParent !== null) || forms[0];
    if (!form) return;

    const buttonHost = form.querySelector('.product-form__buttons');
    if (buttonHost) form.insertBefore(root, buttonHost); else form.prepend(root);

    const memberActive = root.dataset.memberActive === 'true';
    const loggedIn = root.dataset.loggedIn === 'true';
    const openButton = root.querySelector('[data-cc-open]');
    const openLabel = root.querySelector('[data-cc-open-label]');
    const openFee = root.querySelector('[data-cc-open-fee]');
    const saved = root.querySelector('[data-cc-saved]');
    const savedSummary = root.querySelector('[data-cc-saved-summary]');
    const removeButton = root.querySelector('[data-cc-remove]');
    const modal = root.querySelector('[data-cc-modal]');
    const dialog = root.querySelector('[data-cc-dialog]');
    const closeButtons = [...root.querySelectorAll('[data-cc-close]')];
    const saveButton = root.querySelector('[data-cc-save]');
    const error = root.querySelector('[data-cc-error]');
    const variantInput = form.querySelector('input[name="id"]');
    const addButton = form.querySelector('[name="add"]');
    const dynamicCheckout = form.querySelector('.btn-checkout-dynamic,.shopify-payment-button');

    const sizeRadios = [...root.querySelectorAll('[data-cc-size-radio]')];
    const customSizeWrap = root.querySelector('[data-cc-custom-size-wrap]');
    const customSize = root.querySelector('[data-cc-custom-size]');
    const color = root.querySelector('[data-cc-color]');
    const customColorWrap = root.querySelector('[data-cc-custom-color-wrap]');
    const customColor = root.querySelector('[data-cc-custom-color]');
    const type = root.querySelector('[data-cc-type]');
    const placement = root.querySelector('[data-cc-placement]');
    const customPlacementWrap = root.querySelector('[data-cc-custom-placement-wrap]');
    const customPlacement = root.querySelector('[data-cc-custom-placement]');
    const text = root.querySelector('[data-cc-text]');
    const textColor = root.querySelector('[data-cc-text-color]');
    const customTextColorWrap = root.querySelector('[data-cc-custom-text-color-wrap]');
    const customTextColor = root.querySelector('[data-cc-custom-text-color]');
    const reference = root.querySelector('[data-cc-reference]');
    const instructions = root.querySelector('[data-cc-instructions]');
    const choices = [...root.querySelectorAll('[data-cc-choice]')];
    const join = root.querySelector('[data-cc-join]');
    const day = root.querySelector('[data-cc-dob-day]');
    const month = root.querySelector('[data-cc-dob-month]');
    const year = root.querySelector('[data-cc-dob-year]');
    const profileSize = root.querySelector('[data-cc-profile-size]');
    const profileSizeCustomWrap = root.querySelector('[data-cc-profile-size-custom-wrap]');
    const profileSizeCustom = root.querySelector('[data-cc-profile-size-custom]');
    const profileFit = root.querySelector('[data-cc-profile-fit]');
    const profileFitCustomWrap = root.querySelector('[data-cc-profile-fit-custom-wrap]');
    const profileFitCustom = root.querySelector('[data-cc-profile-fit-custom]');

    const reviewSize = root.querySelector('[data-cc-review-size]');
    const reviewColor = root.querySelector('[data-cc-review-color]');
    const reviewType = root.querySelector('[data-cc-review-type]');
    const reviewText = root.querySelector('[data-cc-review-text]');
    const reviewPlacement = root.querySelector('[data-cc-review-placement]');
    const reviewFee = root.querySelector('[data-cc-review-fee]');

    let configured = false;
    let previousFocus = null;
    let config = null;

    const showError = (message) => {
      if (!error) return;
      error.textContent = message || '';
      error.hidden = !message;
      if (message) error.scrollIntoView({behavior:'smooth',block:'nearest'});
    };

    const selectedSizeRaw = () => sizeRadios.find((radio) => radio.checked)?.value || '';
    const selectedSize = () => selectedSizeRaw() === 'Any more' ? clean(customSize?.value) : selectedSizeRaw();
    const selectedColor = () => color?.value === 'Any more' ? clean(customColor?.value) : clean(color?.value);
    const selectedPlacement = () => placement?.value === 'Any more' ? clean(customPlacement?.value) : clean(placement?.value);
    const selectedTextColor = () => textColor?.value === 'Any more' ? clean(customTextColor?.value) : clean(textColor?.value);
    const selectedChoice = () => memberActive ? 'member' : (choices.find((choice) => choice.checked)?.value || '');
    const selectedProfileSize = () => profileSize?.value === 'Any more' ? clean(profileSizeCustom?.value) : clean(profileSize?.value);
    const selectedProfileFit = () => profileFit?.value === 'Any more' ? clean(profileFitCustom?.value) : clean(profileFit?.value);

    const feeText = () => {
      if (memberActive) return 'FREE · MEMBER';
      if (selectedChoice() === 'membership') return 'FREE · MEMBERSHIP';
      if (selectedChoice() === 'fee') return '₹299 / ITEM';
      return 'Choose below';
    };

    const updateConditionalFields = () => {
      if (customSizeWrap) customSizeWrap.hidden = selectedSizeRaw() !== 'Any more';
      if (customColorWrap) customColorWrap.hidden = color?.value !== 'Any more';
      if (customPlacementWrap) customPlacementWrap.hidden = placement?.value !== 'Any more';
      if (customTextColorWrap) customTextColorWrap.hidden = textColor?.value !== 'Any more';
      if (join) join.hidden = selectedChoice() !== 'membership';
      if (profileSizeCustomWrap) profileSizeCustomWrap.hidden = profileSize?.value !== 'Any more';
      if (profileFitCustomWrap) profileFitCustomWrap.hidden = profileFit?.value !== 'Any more';
    };

    const updateReview = () => {
      if (reviewSize) reviewSize.textContent = selectedSize() || '—';
      if (reviewColor) reviewColor.textContent = selectedColor() || '—';
      if (reviewType) reviewType.textContent = clean(type?.value) || '—';
      if (reviewText) reviewText.textContent = clean(text?.value) || '—';
      if (reviewPlacement) reviewPlacement.textContent = selectedPlacement() || '—';
      if (reviewFee) reviewFee.textContent = feeText();
    };

    const isPurchasable = () => Boolean(Number(variantInput?.value)) && Boolean(addButton) && !addButton.disabled;

    const syncAvailability = () => {
      const available = isPurchasable();
      if (openButton) {
        openButton.disabled = !available;
        openButton.setAttribute('aria-disabled', String(!available));
      }
      if (saveButton) saveButton.disabled = !available;

      if (!available) {
        if (openLabel) openLabel.textContent = 'Customization unavailable';
        if (openFee) openFee.textContent = ' · Select an available option';
        if (!modal?.hidden) showError('The selected product option is unavailable. Choose an available option on the product page before saving.');
      } else {
        if (openLabel) openLabel.textContent = configured ? 'Edit customization' : 'Customize this piece';
        if (openFee) openFee.textContent = memberActive ? ' · FREE' : configured && config?.choice === 'membership' ? ' · FREE' : ' · ₹299';
        if (!modal?.hidden && error?.textContent?.includes('selected product option is unavailable')) showError('');
      }
      return available;
    };

    const openModal = () => {
      if (!syncAvailability()) return;
      previousFocus = document.activeElement;
      showError('');
      updateConditionalFields();
      updateReview();
      modal.hidden = false;
      document.body.classList.add('cc-customizer-v4-open');
      requestAnimationFrame(() => dialog?.focus());
    };

    const closeModal = () => {
      modal.hidden = true;
      document.body.classList.remove('cc-customizer-v4-open');
      if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
    };

    const summaryText = () => {
      const values = [config?.size, config?.color, config?.type, config?.placement].filter(Boolean);
      return values.length ? `Customization: ${values.join(' · ')}` : 'Customization saved';
    };

    const applySavedState = () => {
      if (!configured || !config) {
        saved.hidden = true;
        if (dynamicCheckout) dynamicCheckout.hidden = false;
        syncAvailability();
        return;
      }
      saved.hidden = false;
      savedSummary.textContent = summaryText();
      if (dynamicCheckout) dynamicCheckout.hidden = true;
      syncAvailability();
    };

    const validateConfiguration = () => {
      showError('');
      if (!isPurchasable()) return 'The selected product option is unavailable. Choose an available option before saving.';
      if (!selectedSizeRaw()) return 'Please select a customization size.';
      if (selectedSizeRaw() === 'Any more' && !clean(customSize?.value)) return 'Please enter your custom size or measurements.';
      if (!clean(color?.value)) return 'Please select a requested colour.';
      if (color?.value === 'Any more' && !clean(customColor?.value)) return 'Please enter the exact colour or shade.';
      if (!clean(type?.value)) return 'Please select the customization type.';
      if (!clean(placement?.value)) return 'Please select the placement.';
      if (placement?.value === 'Any more' && !clean(customPlacement?.value)) return 'Please enter the exact placement.';
      if ((type?.value === 'Text / Name' || type?.value === 'Initials / Monogram') && !clean(text?.value)) return 'Please enter the exact custom text or initials.';
      if (textColor?.value === 'Any more' && !clean(customTextColor?.value)) return 'Please enter the exact text or print colour.';

      const choice = selectedChoice();
      if (!memberActive && !choice) return 'Choose membership or continue with the ₹299 customization fee.';
      if (choice === 'membership' && !loggedIn) return 'Log in or create an account to join membership, or choose the ₹299 customization option.';
      if (choice === 'membership') {
        const dob = validDob(year?.value, month?.value, day?.value);
        if (!dob) return 'Please enter a valid date of birth for the membership profile.';
        if (!selectedProfileSize()) return 'Please select or enter your preferred membership size.';
        if (!selectedProfileFit()) return 'Please select or enter your preferred fit.';
      }
      return '';
    };

    const collectConfiguration = () => {
      const choice = selectedChoice();
      return {
        size:selectedSize(),
        color:selectedColor(),
        type:clean(type?.value),
        placement:selectedPlacement(),
        text:clean(text?.value),
        textColor:selectedTextColor(),
        reference:clean(reference?.value),
        instructions:clean(instructions?.value),
        choice,
        dob:choice === 'membership' ? validDob(year?.value,month?.value,day?.value) : '',
        profileSize:choice === 'membership' ? selectedProfileSize() : '',
        profileFit:choice === 'membership' ? selectedProfileFit() : ''
      };
    };

    const removeConfiguration = () => {
      configured = false;
      config = null;
      applySavedState();
    };

    openButton?.addEventListener('click', openModal);
    closeButtons.forEach((button) => button.addEventListener('click', closeModal));
    removeButton?.addEventListener('click', removeConfiguration);

    sizeRadios.forEach((radio) => radio.addEventListener('change', () => { updateConditionalFields(); updateReview(); }));
    [color,type,placement,text,textColor,customSize,customColor,customPlacement,customTextColor,reference,instructions,profileSize,profileSizeCustom,profileFit,profileFitCustom,day,month,year].forEach((field) => field?.addEventListener('input', () => { updateConditionalFields(); updateReview(); }));
    [color,type,placement,textColor,profileSize,profileFit,day,month,year].forEach((field) => field?.addEventListener('change', () => { updateConditionalFields(); updateReview(); }));
    choices.forEach((choice) => choice.addEventListener('change', () => { updateConditionalFields(); updateReview(); }));

    saveButton?.addEventListener('click', () => {
      const message = validateConfiguration();
      if (message) { showError(message); return; }
      config = collectConfiguration();
      configured = true;
      applySavedState();
      closeModal();
    });

    modal?.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') { event.preventDefault(); closeModal(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...modal.querySelectorAll('button:not([disabled]),a[href],input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])')].filter((node) => !node.hidden && node.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });

    const addItems = async (items, attributes) => {
      const addResponse = await fetch(`${window.Shopify.routes.root}cart/add.js`, {
        method:'POST',
        headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({items})
      });
      if (!addResponse.ok) {
        const payload = await addResponse.json().catch(() => ({}));
        throw new Error(payload.description || payload.message || 'Unable to add the customized item to cart.');
      }
      const updateResponse = await fetch(`${window.Shopify.routes.root}cart/update.js`, {
        method:'POST',
        headers:{'Content-Type':'application/json',Accept:'application/json'},
        body:JSON.stringify({attributes})
      });
      if (!updateResponse.ok) throw new Error('The item was added, but we could not save the customization order notes. Please review your cart.');
      window.location.assign(root.dataset.cartUrl);
    };

    form.addEventListener('submit', async (event) => {
      if (!configured || !config) return;
      event.preventDefault();
      event.stopImmediatePropagation();

      if (!isPurchasable()) {
        showError('The selected product option is unavailable. Choose an available option before adding to cart.');
        openModal();
        return;
      }

      const variantId = Number(variantInput?.value);
      const quantity = Math.max(1, Number(form.querySelector('input[name="quantity"]')?.value || 1));
      if (!variantId) { showError('Please select an available product option.'); openModal(); return; }

      const isJoining = !memberActive && config.choice === 'membership';
      const pairId = `cc-${Date.now()}-${window.crypto?.randomUUID?.() || Math.random().toString(36).slice(2)}`;
      const feeLabel = memberActive ? 'Free - Active Member' : isJoining ? 'Free - Membership purchased in this order' : '₹299 per customized item';
      const productProps = {
        'Order Type':memberActive || isJoining ? 'MEMBER ORDER' : 'NON-MEMBER ORDER',
        'Customization':'Requested',
        'Customization Charge':feeLabel,
        'Customization Size':config.size,
        'Customization Color':config.color,
        'Customization Type':config.type,
        'Custom Text':config.text || '',
        'Text / Print Color':config.textColor || '',
        'Customization Placement':config.placement,
        'Artwork / Reference Link':config.reference || '',
        'Customization Instructions':config.instructions || '',
        '_Charcode Customization':'true',
        '_Charcode Pair':pairId
      };

      const items = [{id:variantId,quantity,properties:productProps}];

      if (isJoining) {
        items.push({id:Number(root.dataset.membershipVariantId),quantity:1,properties:{
          'Order Type':'MEMBER ORDER - MEMBERSHIP PURCHASE',
          'Date of Birth':config.dob,
          'Preferred Size':config.profileSize,
          'Preferred Fit':config.profileFit,
          'Usual Fit / Size':config.profileSize,
          'Membership Term':'1 Year',
          'Free Customization Benefit':'Active for 1 year after paid order',
          'Birthday Gift Benefit':'Included - 24 hour claim window',
          '_Charcode Service':'membership',
          '_Charcode Pair':pairId
        }});
      } else if (!memberActive) {
        items.push({id:Number(root.dataset.customizationVariantId),quantity,properties:{
          'Order Type':'NON-MEMBER ORDER',
          'Customization Charge':'₹299 per customized item',
          'Customized Product':root.dataset.productTitle,
          'Customized Variant ID':String(variantId),
          'Customization Size':config.size,
          'Customization Color':config.color,
          '_Charcode Service':'customization',
          '_Charcode Pair':pairId
        }});
      }

      const attributes = {
        'Membership Order Type':memberActive || isJoining ? 'MEMBER ORDER' : 'NON-MEMBER ORDER',
        'Customization Status':feeLabel,
        'Cord Cult Customized Order':'Yes'
      };
      if (isJoining) {
        attributes['Cord Cult Membership Purchase'] = 'Yes';
        attributes['Membership Date of Birth'] = config.dob;
        attributes['Membership Preferred Size'] = config.profileSize;
        attributes['Membership Preferred Fit'] = config.profileFit;
        attributes['Membership Term'] = '1 Year';
      }

      if (addButton) addButton.disabled = true;
      try {
        await addItems(items, attributes);
      } catch (requestError) {
        if (addButton) addButton.disabled = false;
        openModal();
        showError(requestError.message || 'Unable to add the customized item to cart. Please try again.');
        syncAvailability();
      }
    }, true);

    const availabilityObserver = addButton ? new MutationObserver(() => syncAvailability()) : null;
    if (availabilityObserver && addButton) availabilityObserver.observe(addButton,{attributes:true,attributeFilter:['disabled']});
    document.addEventListener('change', () => setTimeout(syncAvailability,0));
    document.addEventListener('variant:change', () => setTimeout(syncAvailability,0));

    updateConditionalFields();
    updateReview();
    syncAvailability();
    setTimeout(syncAvailability,250);
    setTimeout(syncAvailability,800);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
